/**
 * Turn JS object into a string separated by an `&`. Used to convert a JS object into a potential query parameter. If used as a query parameter, the implementer has to add `?` before this output.
 * Example input: `{ hello: "world", foo: "bar", nothing: undefined }`
 * output: `"hello=world&foo=bar"`
 *
 * @param object a JS object where keys might have `undefined` or `null` as their value.
 * @returns A string separated by an `&` where all the key-value pairs are in the format of `key=value` with `&` as the prefix if it is not the first element.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transformObjectToQueryParams = (object: Record<string, any>) => {
    const filteredInput = Object.entries(object).filter(
        ([, value]) => value != null && value !== 'undefined' && value !== 'null' && value !== '',
    );

    const inputAsParamList = filteredInput.map(([key, value]) => {
        const encodedValue = encodeURIComponent(value.toString());
        return `${key}=${encodedValue}`;
    });

    return inputAsParamList.join('&');
};

export default transformObjectToQueryParams;
